/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForTemplateBase extends models.ScheduleExecutionParameterServiceAccountBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForTemplateBase");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForTemplateBase.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForTemplateBase>): ScheduleExecutionParameterForTemplateBase {
        let obj = Object.assign(new ScheduleExecutionParameterForTemplateBase(), model);
        ScheduleExecutionParameterForTemplateBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForTemplateBase>): ScheduleExecutionParameterForTemplateBase {
        if (!model) return null;
        return ScheduleExecutionParameterForTemplateBase.newInstance(<ScheduleExecutionParameterForTemplateBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForTemplateBase) {
        if (!obj) return;

        models.ScheduleExecutionParameterForTemplateBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForTemplateBase): boolean {
        if (models.ScheduleExecutionParameterServiceAccountBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForTemplateBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
